/* eslint-disable function-paren-newline */
import { formatEnumString } from 'components/Onboarding/Mle/mle.utils';
import { capitaliseString } from '../../../utils/helperMethods';

function MerchantStaticInfo(data) {
    this.relationshipManagers = this.createRelationshipManagers(data);
    this.categoryMap = this.createCategoryMap(data);
    this.merchantEntityList = this.createEntityList(data);
}

MerchantStaticInfo.prototype = Object.assign(MerchantStaticInfo.prototype, {
    createRelationshipManagers(data) {
        return (
            data &&
            data.relationshipManagerInfoResponse &&
            data.relationshipManagerInfoResponse.map(row =>
                this.createManagerRow(row)
            )
        );
    },

    createCategoryMap(data) {
        return (
            data &&
            data.categoryCodeMappingResponse &&
            data.categoryCodeMappingResponse &&
            Object.keys(
                data.categoryCodeMappingResponse.categoryCodeMap
            ).map(row =>
                this.createCategoryRow(
                    row,
                    data.categoryCodeMappingResponse.categoryCodeMap
                )
            )
        );
    },
    createManagerRow(row) {
        const { email, name } = row;
        return {
            email,
            name,
            value: email,
        };
    },

    createCategoryRow(keys, originalData) {
        return {
            name: keys && capitaliseString(keys),
            value: keys,
            options: originalData[keys],
        };
    },
    createEntityList(data){
        return (
            data &&
            data.merchantEntityStatusList &&
            data.merchantEntityStatusList.map((value) =>{
              return { "name": formatEnumString(value), "value": value }
            }
            )
        );
    }
});

export default MerchantStaticInfo;
